import {useEffect, useState} from 'react'
import {Form, InputGroup} from 'react-bootstrap'
import CurrencyInput from 'react-currency-input-field'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'

export const InputSellingPrice = () => {
  const {t} = useTranslation()
  const [language, setLanguage] = useState<any>()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  const handleChange = (value: string) => {
    dispatch(setJbpDetail({...jbp, selling_price: Number(value)}))
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <Form.Group controlId='input-selling-price'>
      <Form.Label>{t('Selling Price')}</Form.Label>
      <InputGroup className='mb-3' size='sm'>
        <InputGroup.Text>
          <span className='px-1'>Rp</span>
        </InputGroup.Text>
        <CurrencyInput
          className='form-control form-control-sm'
          placeholder={t('Selling Price')}
          defaultValue={jbp?.selling_price ?? 0}
          decimalSeparator={language === 'en' ? '.' : ','}
          groupSeparator={language === 'en' ? ',' : '.'}
          decimalsLimit={-1}
          onValueChange={(value: any) => handleChange(value ?? '')}
        />
      </InputGroup>
    </Form.Group>
  )
}
